import { z } from 'zod';

export const ReviewResponseSchema = z.object({
  id: z.string(),
  bookingId: z.string(),
  tutorId: z.string(),
  parentId: z.string(),
  rating: z.number(),
  comment: z.string().nullable(),
  createdAt: z.string(),
});
export type ReviewResponse = z.infer<typeof ReviewResponseSchema>;

export const SubmitReviewSchema = z.object({
  bookingId: z.string(),
  rating: z.number().int().min(1).max(5),
  comment: z.string().trim().max(500).nullable().optional(),
});
export type SubmitReviewInput = z.infer<typeof SubmitReviewSchema>;
